/**
 * Default post-auth landing path by platform role (INBOX-AS-HOME-1).
 * ADMIN → /home (Admin Home); MEMBER + VIEWER → /inbox.
 */
import { isPlatformAdmin, type UserLike } from '@/utils/access';

export function defaultPostLoginPath(user: UserLike): string {
  if (isPlatformAdmin(user)) return '/home';
  return '/inbox';
}
